import useBreadcrumbs from "use-react-router-breadcrumbs";
import { Link } from "react-router-dom";
import { StyledBreadcrumbs } from "../../styles/StyledBreadcrumbs";

export default function Breadcrumbs() {
	let crumbs = [];

	try {
		crumbs = useBreadcrumbs();
	} catch (err) {
		// Breadcrumbs rendered outside Router context - fail silently
		return null;
	}

	return (
		<StyledBreadcrumbs>
			{crumbs.map(({ breadcrumb }) => (
				<Link key={breadcrumb.key} to={breadcrumb.key}>
					{breadcrumb}
				</Link>
			))}
		</StyledBreadcrumbs>
	);
}
